import React from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import MultiSelect from "react-multi-select-component";
import "react-toastify/dist/ReactToastify.css";
import {
  getReport,
  fetchSearchData,
} from "./../../stores/services/report.service";
import moment from "moment";
import jsPDF from "jspdf";
import * as htmlToImage from "html-to-image";
import { BsTable } from "react-icons/bs";
import { getFunds } from "./../../stores/services/funds.service";
import { getDateType, checkFieldDisplay } from "../transactions/reportFields";
import { getAllBanks } from "./../../stores/services/bank.service";
import { getBranchByBankName } from "./../../stores/services/branch.service";
// import { bankAccountDropdown } from './fields';
import { bankAccountDropdownReport } from "./fields";
import html2pdf from "html2pdf.js";

// interface For report Object which we need to send in Api
interface FieldValues {
  fund_code: string;
  account_no: string;
  folio_no: string;
  from_date: string;
  to_date: string;
  txn_id: string;
  date_type: string;
  txn_type: string;
  bank_code: string;
  branch_code: string;
  issue_date: string;
  maturity_date: string;
  settlement_date: string;
  security_type: string;
  to_bank_code: string;
  payment_type: string;
  status: string;
}

const BankAccountReport = () => {
  const [loading, setLoading] = useState(false);
  const email = sessionStorage.getItem("email") || "";
  const [data, setData] = useState<any>([]);
  const [temp, setTemp] = useState("");
  let date = new Date();

  const [reportTxn, setReportTxn] = useState<any>([]);
  let [fields, setFields] = useState<FieldValues>({
    fund_code: "",
    txn_id: "",
    account_no: "",
    date_type: "",
    folio_no: "",
    from_date: moment(date).format("DD-MM-YYYY"),
    to_date: moment(date).format("DD-MM-YYYY"),
    txn_type: "",
    bank_code: "",
    branch_code: "",
    issue_date: "",
    maturity_date: "",
    settlement_date: "",
    security_type: "",
    to_bank_code: "",
    payment_type: "",
    status: "",
  });
  // const [dropdownList, setDropdownList] = useState<any>(bankAccountDropdown);
  const [dropdownList, setDropdownList] = useState<any>(
    bankAccountDropdownReport,
  );

  const formatData = (val) => {
    let words = val.split("_");
    return `${words[0]} ${words[1] ? words[1] : ""}`;
  };
  const [changesCheck, setChangesCheck] = useState("");

  const setDefaultValue = (type) => {
    // eslint-disable-next-line
    ((fields["fund_code"] = ""),
      (fields["txn_id"] = ""),
      (fields["account_no"] = ""),
      (fields["date_type"] = ""),
      (fields["folio_no"] = ""),
      (fields["from_date"] = moment(date).format("DD-MM-YYYY")),
      (fields["to_date"] = moment(date).format("DD-MM-YYYY")),
      (fields["txn_type"] = type),
      (fields["bank_code"] = ""),
      (fields["branch_code"] = ""),
      (fields["issue_date"] = ""),
      (fields["status"] = ""),
      (fields["maturity_date"] = ""),
      (fields["settlement_date"] = ""),
      (fields["security_type"] = ""),
      (fields["to_bank_code"] = ""),
      (fields["payment_type"] = ""),
      setFields(fields));
    setChangesCheck(type);
  };

  const [allFunds, setAllFunds] = useState<any>([]);
  // const [allDropdownColumns, setAllDropdownColumns] = useState<any>(
  //   bankAccountDropdown
  // );
  const [allDropdownColumns, setAllDropdownColumns] = useState<any>(
    bankAccountDropdownReport,
  );
  const [fundLoading, setFundLoading] = useState<boolean>(false);
  const [bankNameData, setBankNameData] = useState<any>([]);
  const [branchLoading, setBranchLoading] = useState<boolean>(false);
  const [branchCheckFlag, setBranchCheckFlag] = useState(false);
  const [allbranchesData, setAllBranchesData] = useState<any>([]);

  React.useEffect(() => {
    const UploadTxn = async () => {
      try {
        const response = await getFunds(email);
        setAllFunds(response.data.data);
        if (response.data.data.length > 0) {
          setFundLoading(false);
        } else {
          setFundLoading(true);
        }
      } catch (err: any) {
        if (err.response !== undefined) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      }
      try {
        const response = await getAllBanks(email);
        setBankNameData(response.data.data);
      } catch (err: any) {
        if (err.response !== undefined) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      }
    };
    UploadTxn();
  }, []);
  let txnTypes = JSON.parse(sessionStorage.getItem("txnType") || "");

  const getBranchByName = async (name: string) => {
    setBranchLoading(true);
    allbranchesData.length = 0;
    setAllBranchesData(allbranchesData);
    //get all branches for selected bank for dropdown
    try {
      const response = await getBranchByBankName(email, name);
      setAllBranchesData(response.data.data);
      if (response.data.data.length > 0) {
        setBranchCheckFlag(false);
      } else {
        setBranchCheckFlag(true);
      }
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message);
      } else {
        toast.error(err.message);
      }
    }
    setBranchLoading(false);
  };

  const CapTxnType = (type: any) => {
    let i, txType;
    for (i = 0; i < txnTypes.length; i++) {
      if (txnTypes[i].api_name === type) {
        txType = txnTypes[i].dis_name;
        break;
      }
    }
    return txType;
  };

  const renderFundsDropdown = () => {
    return allFunds.map((item: any, index: string) => {
      return (
        <option key={index} value={item.symbol_code}>
          {item.symbol_code}-{item.fund_name}
        </option>
      );
    });
  };

  const renderDropdownValues = (selectedCol, transaction) => {
    let res = transaction[selectedCol.value];
    if (
      selectedCol.label.includes("date") ||
      selectedCol.label.includes("Date")
    ) {
      res = moment(transaction[selectedCol.value]).format("DD-MMM-YYYY");
    }
    if (selectedCol.value === "txnr_type") {
      res = CapTxnType(transaction[selectedCol.value]);
    }
    return res;
  };

  //render dropdown for bank name data
  const renderBankNameDropdown = () => {
    return bankNameData.map((item: any, index: string) => {
      return (
        <option key={index} value={item.bank_code}>
          {item.bank_code}-{item.bank_name}
        </option>
      );
    });
  };

  //render dropdown for branch name data
  const renderBranchsDropdown = () => {
    return allbranchesData.map((item: any, index: string) => {
      return (
        <option key={index} value={item.branch_code}>
          {item.branch_code}-{item.branch_name}
        </option>
      );
    });
  };

  //code for search data for Reports
  const searchData = async () => {
    try {
      const searchResponse = await fetchSearchData(email, fields);
      setReportTxn(searchResponse.data.data);
      let temp = Object.keys(searchResponse.data.data[0]).map((val) => {
        return { label: formatData(val), value: val };
      });
      // setAllDropdownColumns(temp);
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message);
      } else {
        toast.error(err.message);
      }
      setReportTxn([]);
    }
  };

  //Print Report
  const printReport = () => {
    var node = document.getElementById("printDiv") as HTMLElement;
    htmlToImage
      .toPng(node)
      .then(function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        var doc = new jsPDF("p", "px", "a4"); // make A4 size Pdf file
        const imgProps = doc.getImageProperties(img);
        const pdfWidth = doc.internal.pageSize.getWidth(); // set It width
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width; // set its Height
        doc.addImage(dataUrl, "PNG", 0, 0, pdfWidth, pdfHeight); // add image to Pdf
        doc.save("Report.pdf"); // Save the cheque
      })
      .catch(function (error) {
        console.error("oops, something went wrong!", error);
      });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">
                      Fund Wise Bank Account Report
                    </h4>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col md="3">
                        <div className="form-group  ">
                          <label>Fund Name</label>
                          <select
                            className="form-control"
                            value={fields["fund_code"]}
                            onChange={(e) => {
                              setFields({
                                ...fields,
                                fund_code: e.target.value,
                              });
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Fund
                            </option>
                            {renderFundsDropdown()}
                          </select>
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="form-group  ">
                          <label>Bank Name</label>
                          <select
                            className="form-control"
                            value={fields["bank_code"]}
                            onChange={(e) => {
                              setFields({
                                ...fields,
                                bank_code: e.target.value,
                              });
                              getBranchByName(e.target.value);
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Bank
                            </option>
                            {renderBankNameDropdown()}
                          </select>
                        </div>
                      </Col>
                      {/* <Col md="4">
                <div className="form-group  ">
                  <label>Branch Name</label>
                  {branchLoading ? (
                    // <div className="input-3">
                    //   <div className="ml-2">Branch Loading</div>
                    //   <img
                    //     src="assets/spin-loader.svg"
                    //     className="ml-auto pb-2 center"
                    //     alt=""
                    //     width={40}
                    //     height={70}
                    //   />
                    // </div>

                  <div className="form-group">
                    <div className="form-control" >Branch Loading
                        <i className="fa fa-spinner fa-spin fa-1x ml-2 " ></i> 
                    </div> 
                  </div>

                  ) : (
                    <select
                      className="form-control"
                      value={fields['branch_code']}
                      onChange={(e) => {
                        setFields({
                          ...fields,
                          branch_code: e.target.value,
                        });
                      }}
                    >
                      <option value="" defaultChecked hidden>
                        {branchCheckFlag ? 'No Branch Found' : 'Select Branch'}
                      </option>
                      {renderBranchsDropdown()}
                    </select>
                  )}
                </div>
              </Col> */}
                      <Col md="3">
                        <div className="form-group  ">
                          <label>Fund Bank A/c No</label>
                          <input
                            type="text"
                            className="form-control"
                            value={fields["account_no"]}
                            onChange={(e) => {
                              setFields({
                                ...fields,
                                account_no: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="form-group  ">
                          <label>Transaction Status</label>
                          <select
                            className="form-control"
                            value={fields["status"]}
                            onChange={(e) => {
                              setFields({
                                ...fields,
                                status: e.target.value,
                              });
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select type
                            </option>
                            <option value="COMPLETED">Completed</option>
                            <option value="COMPLIANCE">Compliance</option>
                            <option value="INREVIEW">In Review</option>
                            <option value="SIGNATORY-A">Signatory A</option>
                            <option value="SIGNATORY-B">Signatory B</option>
                            <option value="REJECTED-TRUSTEE">Rejected</option>
                          </select>
                        </div>
                      </Col>
                    </Row>

                    <div className="row">
                      <div className="col-md-3">
                        <label>From</label>
                        <div className="form-group ">
                          <input
                            type="date"
                            value={fields["from_date"]}
                            className="form-control"
                            onChange={(e) => {
                              setFields({
                                ...fields,
                                from_date: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <label>To</label>
                        <div className="form-group">
                          <input
                            type="date"
                            value={fields["to_date"]}
                            className="form-control"
                            onChange={(e) => {
                              setFields({
                                ...fields,
                                to_date: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-3">
                      {/* here Search Button */}
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          searchData();
                        }}
                        disabled={Boolean(loading)}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          <span>Search</span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>

                {reportTxn.length > 0 && (
                  <Row>
                    <Col md="8"></Col>
                    <Col md="4">
                      <div className="mt-3 mr-3 mb-4">
                        {reportTxn.length > 0 ? (
                          <MultiSelect
                            options={allDropdownColumns}
                            value={dropdownList}
                            onChange={setDropdownList}
                            labelledBy={"Select Columns"}
                            className="multi-select"
                            overrideStrings={{
                              selectAll: "Select all Columns",
                              selectSomeItems: "Select Columns",
                            }}
                          />
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </Col>
                  </Row>
                )}

                <div className="card">
                  <div className="card-body">
                    <div
                      id="printDiv"
                      className="p-2"
                      style={{ background: "white", color: "black" }}
                    >
                      {reportTxn.length > 0 ? (
                        <>
                          <div className="title-row m-4 d-flex justify-content-center">
                            <h3 className="text-black">
                              Fund Wise Bank Account Report
                            </h3>
                          </div>

                          <Row>
                            <Col md="4">
                              <Row>
                                <Col md="5">
                                  <span style={{ fontWeight: "bold" }}>
                                    Report Date:
                                  </span>
                                </Col>
                                <Col md="6">
                                  <span>
                                    {moment(date).format("DD-MM-YYYY")}
                                  </span>
                                </Col>
                              </Row>
                            </Col>
                            {fields["fund_code"] !== "" && (
                              <Col md="4">
                                <Row>
                                  <Col md="5">
                                    <span style={{ fontWeight: "bold" }}>
                                      Fund Name:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span>{fields["fund_code"]}</span>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                            {fields["account_no"] !== "" && (
                              <Col md="4">
                                <Row>
                                  <Col md="5">
                                    <span style={{ fontWeight: "bold" }}>
                                      Fund Bank A/c No:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span>{fields["account_no"]}</span>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                            {fields["status"] !== "" && (
                              <Col md="4">
                                <Row>
                                  <Col md="5">
                                    <span style={{ fontWeight: "bold" }}>
                                      Status:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span>{fields["status"]}</span>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                            {fields["bank_code"] !== "" && (
                              <Col md="4">
                                <Row>
                                  <Col md="5">
                                    <span style={{ fontWeight: "bold" }}>
                                      Fund Bank :
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span>{fields["bank_code"]}</span>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                            {fields["branch_code"] !== "" && (
                              <Col md="4">
                                <Row>
                                  <Col md="5">
                                    <span style={{ fontWeight: "bold" }}>
                                      Fund Branch:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span>{fields["branch_code"]}</span>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                            {fields["from_date"] !== "" && (
                              <Col md="4">
                                <Row>
                                  <Col md="5">
                                    <span style={{ fontWeight: "bold" }}>
                                      From Date:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span>
                                      {moment(fields["from_date"]).format(
                                        "DD-MM-YYYY",
                                      )}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                            {fields["to_date"] !== "" && (
                              <Col md="4">
                                <Row>
                                  <Col md="5">
                                    <span style={{ fontWeight: "bold" }}>
                                      To Date:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span>
                                      {moment(fields["to_date"]).format(
                                        "DD-MM-YYYY",
                                      )}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                          </Row>
                          <div
                            style={{
                              overflowX: "auto",
                              overflowY: "hidden",
                            }}
                          >
                            <table
                              className="report"
                              style={{ color: "black" }}
                            >
                              <thead style={{ alignSelf: "center" }}>
                                <tr>
                                  {dropdownList.map((item, index) => {
                                    return (
                                      <th key={index}>
                                        <span
                                          style={{
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {item.label.toString()}
                                        </span>
                                      </th>
                                    );
                                  })}
                                </tr>
                              </thead>
                              <tbody className="report-table-body">
                                {reportTxn.map(
                                  (transaction: any, index: number) => {
                                    return (
                                      <tr key={index}>
                                        {dropdownList.map((item, i) => {
                                          return (
                                            <td key={i}>
                                              {renderDropdownValues(
                                                item,
                                                transaction,
                                              )}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    );
                                  },
                                )}
                              </tbody>
                            </table>
                          </div>
                        </>
                      ) : (
                        <div className="table-empty">
                          <BsTable className="icon" />
                          <p className="text-center empty-text">
                            No record found
                          </p>
                        </div>
                      )}
                    </div>
                    <button
                      className="btn btn-primary mt-3"
                      onClick={() => {
                        printReport();
                      }}
                    >
                      Print
                    </button>
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BankAccountReport;
